import React from "react";

const DetailLabel = ({ text, header }) => {
    return (
        <>
        <div className="text-right flex justify-start">
            <h4 className="font-medium text-sm leading-[14px]">{header}</h4>
        </div>
        <div>
            <span className="font-normal text-sm leading-[14px] -ml-24">{text}</span>
        </div>
        </>
    );
};
export default DetailLabel;
